/*
 * 戒导航 · 戒打卡模块（jiedh/checkin）—— 前台扩展声明
 *
 * 设计依据：doc/戒打卡功能设计方案.md §18.2（独立页）、§18.8（通知三件套）。
 *
 * 这里注册五类东西，缺一都会导致对应功能静默失效：
 *   ① new Extend.Routes().add('checkin', '/checkin', CheckinPage)          → 独立页
 *      new Extend.Routes().add('user.checkin', '/u/:username/checkin', ...) → 个人主页 tab（方案 A）
 *   ② new Extend.Store().add('jiedh-checkin-habits', CheckinHabit) → 通知 subject 模型
 *      new Extend.Store().add('jiedh-checkin-records', CheckinRecord)
 *   ③ new Extend.Notification().add('jiedhCheckinMilestone', ...)  → 里程碑通知卡片
 *      new Extend.Notification().add('jiedhCheckinReminder', ...)  → 每日提醒通知卡片
 *
 * ⚠️ type 名一致性（本项目已多次踩坑，务必核对）：
 *   - Store 的 type 必须与后端 Resource::type() 完全一致：
 *       'jiedh-checkin-habits' / 'jiedh-checkin-records'；
 *   - Notification 的 type 必须与后端 Blueprint::getType() 完全一致：
 *       'jiedhCheckinMilestone' / 'jiedhCheckinReminder'。
 *   不一致时：资源被 app.store 静默丢弃；通知组件取不到 → 静默 return null（不显示、不报错）。
 */
import Extend from 'flarum/common/extenders';
import CheckinHabit from '../common/models/CheckinHabit';
import CheckinRecord from '../common/models/CheckinRecord';
import UserPageResolver from 'flarum/forum/resolvers/UserPageResolver';
import CheckinPage from './components/CheckinPage';
import UserCheckinPage from './components/UserCheckinPage';
import CheckinMilestoneNotification from './components/CheckinMilestoneNotification';
import CheckinReminderNotification from './components/CheckinReminderNotification';
export default [
// ① 独立页：/checkin（后端 extend.php 已用 Frontend('forum')->route('/checkin','checkin') 放行）
new Extend.Routes().add('checkin', '/checkin', CheckinPage),
// ①' 个人主页 tab：/u/:username/checkin（方案 A，2026-09-30）
//     与核心 user.security 完全同范式：path 带 :username + 传 UserPageResolver
//     （SPA 内路由时按 username 预取用户数据，供 UserPage 布局使用）。
//     后端无需新增 PHP 路由：核心通用路由 /u/{username}[/{filter}] 已覆盖。
new Extend.Routes().add('user.checkin', '/u/:username/checkin', UserCheckinPage, UserPageResolver),
// ② 前端模型（里程碑通知的 subject = habits，缺它通知面板会整条消失）
new Extend.Store().add('jiedh-checkin-habits', CheckinHabit), new Extend.Store().add('jiedh-checkin-records', CheckinRecord),
// ③ 通知渲染组件（type 与后端 Blueprint::getType() 完全一致）
new Extend.Notification().add('jiedhCheckinMilestone', CheckinMilestoneNotification), new Extend.Notification().add('jiedhCheckinReminder', CheckinReminderNotification)];